<template>
  <button type="submit" class="btn-default" @click="submit">
    <slot></slot>
  </button>
</template>

<script>
export default {
  methods: {
    submit() {
      if (
        this.$parent &&
        this.$parent.submit &&
        typeof this.$parent.submit === 'function'
      ) {
        this.$parent.submit()
      }
    },
  },
}
</script>
